import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzXmas70 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_70: Record<
  Exclude<PageIdWoofzXmas70, PageIdWoofzXmas70.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_XMAS_70]: {
    id: PageId.SUBSCRIPTIONS_XMAS_70,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_XMAS_70]: {
    id: PageId.CHAT_UPSELL_XMAS_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_XMAS_70]: {
    id: PageId.UPSELL_XMAS_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_XMAS_70]: {
    id: PageId.DOWNLOAD_XMAS_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
